import { Box } from "@chakra-ui/react"
import { Helmet } from "react-helmet"
import Footer from "./Footer"
import WithSubnavigation from "./Header"

export default function AppLayout(props) {
    return (
        <div>
            <Helmet>
                <title>{props.pageTitle}</title>
            </Helmet>
            {/* <SideNav /> */}
            <WithSubnavigation />
                <Box
                    maxW="1200px"
                    marginRight="auto"
                    marginLeft="auto"
                    mt={[2, 5]}
                    mb={[2, 5]}
                    p={5}
                    minHeight="82vh"
                >
                    {props.children}
                </Box>
            <Footer />
        </div>
    )
}